import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';
import { lowHeightScreens } from '../../../common/fontElements';

export const Container = styled.div`
  display: flex;
  width: 300px;
  flex: 1 1 0;
  padding: 30px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${colors.baseBackground};

  @media (max-height: ${lowHeightScreens}) {
    padding: 50px 30px;
  }
`;

export const SubText = styled.p`
  font-family: 'Roboto', sans-serif;
  text-align: center;
  font-size: 11px;
  color: ${colors.darkGray1};
  margin-top: 10px;

  @media (max-height: ${lowHeightScreens}) {
    font-size: 10px;
  }
`;

export const WarningCircle = styled.img`
  margin: 10px;
`;
export const StepsIndicatorBox = styled.div`
  background-color: ${colors.lightGray7};
  width: 100%;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
`;

export const StepsIndicatorCircles = styled.img`
  height: 110px;
  margin-right: 8px;
`;

export const StepsIndicatorTextBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const StepsIndicatorText = styled.p`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: ${({ isPending }) => (isPending ? colors.darkGray1 : colors.blue1)};
  margin: 0;
  padding: 0;
`;
